<template>
  <div class="d-flex">
    <div>
      <span class="fa-stack">
        <i class="fas fa-circle fa-stack-2x text-muted"></i>
        <i
          :class="[
            origin[accountTransaction.origin].icon,
            'fa-stack-1x fa-inverse',
          ]"
        ></i>
      </span>
    </div>
    <div class="ml-2">
      <span>{{ accountTransaction.description }}</span>
      <template v-if="accountTransaction.origin == 'br'">
        <span class="text-muted">
          (Documento: {{ accountTransaction.bill_payment_join_bill[0].document }})
        </span>
      </template>
      <button
        class="btn btn-sm btn-link text-info"
        v-if="accountTransaction.origin == 'br'"
        @click.stop="$emit('openBillPaymentModal', accountTransaction)"
      >
        Ver contas
      </button>
      <span
        v-if="accountTransaction.status == 'c'"
        class="badge badge-danger ml-2"
        >Cancelado</span
      >
      <template v-if="accountTransaction.origin == 'br' || accountTransaction.origin == 'o'">
        <template v-if="accountTransaction.person">
          <br>
          <small>{{ accountTransaction.person.name }} </small>
          <small class="text-muted">#{{ accountTransaction.person.person_code }}</small>
        </template>
        <template v-if="!accountTransaction.person &&  accountTransaction.origin == 'o'">
          <br>
          <small>Consumidor Final</small>
        </template>
      </template>
      <template v-if="accountTransaction.account_plan">
        <br />
        <small>
          {{ accountTransaction.account_plan.description }}
        </small>
      </template>
      <br />
      <small class="text-muted"
        >{{ accountTransaction.paid_at | dateBr }}</small
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accountTransaction: {},
  },

  data: () => ({
    origin: {
      o: {
        text: "Vendas",
        icon: "fas fa-shopping-cart",
      },
      br: {
        text: "Contas a receber",
        icon: "fas fa-file-invoice-dollar",
      },
      bp: {
        text: "Contas a pagar",
        icon: "fas fa-file-invoice-dollar",
      },
      c: {
        text: "Lançamento",
        icon: "fas fa-pen",
      },
      t: {
        text: "Transferência",
        icon: "fas fa-exchange-alt",
      },
      dd: {
        text: "Ajuste de Caixa",
        icon: "fas fa-hand-holding-usd",
      },
    },
  }),
};
</script>

<style>
</style>